import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type {
  FileType,
  UploadProps,
} from 'ant-design-vue/es/upload/interface.d.ts'

import type { UploadRequestOption } from 'ant-design-vue/es/vc-upload/interface.d.ts'

import type UploadImage from './upload-image.vue'

export const borderType = ['dotted', 'solid', 'dashed'] as const

export const uploadImageProps = buildProps({
  // 图片宽度
  width: {
    type: Number,
    default: 100,
  },
  // 图片高度
  height: {
    type: Number,
    default: 100,
  },
  // 图片圆角
  borderRadius: {
    type: String,
    default: '6px',
  },
  // 边框形态
  borderType: {
    type: String,
    values: borderType,
    default: 'dashed',
  },
  // 是否支持拖拽
  isDrag: {
    type: Boolean,
    default: false,
  },
  // 上传标题
  uploadTitle: {
    type: String,
    default: '',
  },
  // 上传描述
  uploadTip: {
    type: [String, Boolean],
    default: '',
  },
  // 上传图标
  uploadIcon: {
    type: String,
    default: 'icon-add',
  },
  // 上传图标大小
  uploadIconSize: {
    type: Number,
    default: 30,
  },

  value: {
    type: definePropType<string | string[]>([String, Array]),
    default: [],
  },

  imgLoading: {
    type: Boolean,
    default: false,
  },
  useBase64: {
    type: Boolean,
    default: true,
  },

  maxCount: {
    type: Number,
    default: 1,
  },
  accept: {
    type: String,
    default: '.jpg,.png,.jpeg,.svg',
  },
  imgSize: {
    type: Number,
    default: 2,
  },

  beforeUpload: {
    type: definePropType<UploadProps['beforeUpload']>(Function),
    default: () => true,
  },
  customRequest: {
    type: definePropType<
      (options: UploadRequestOption, base64: string) => void
    >(Function),
    default: (): void => {},
  },

  // 是否开启预览
  isPreview: {
    type: Boolean,
    default: true,
  },

  // 是否开启删除
  isDelete: {
    type: Boolean,
    default: true,
  },
} as const)

export const uploadImageEmits = {
  change: (value: string | string[] | undefined) =>
    value === undefined || typeof value === 'string' || Array.isArray(value),
  'update:value': (value: string | string[] | undefined) =>
    value === undefined || typeof value === 'string' || Array.isArray(value),
} as const

export type RcFileType = FileType

export type RcUploadRequestOption = UploadRequestOption

export type RcUploadProps = UploadProps

// props
export type UploadImageProps = ExtractPropTypes<typeof uploadImageProps>

// emits
export type UploadImageEmits = typeof uploadImageEmits

// instance
export type UploadImageInstance = InstanceType<typeof UploadImage>
